import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
import { ApiService } from './api.service';
import { AppService } from './app.service';
import jwtDecode from 'jwt-decode';
import { PlantList } from '@/Interface/plants';

@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    private product$ = new BehaviorSubject<any>({});
    selectedProduct$ = this.product$.asObservable();

    private selectedPlantNameSubject = new BehaviorSubject<string>('');
    private selectedPlant$ = new BehaviorSubject<PlantList | null>(null);
    selectedPlantName$: Observable<string> = this.selectedPlantNameSubject.asObservable();
    updateSelectedPlantName(plantName: string) {
        this.selectedPlantNameSubject.next(plantName);
    }
    updateSelectedPlant(plant: PlantList | null) {
        this.selectedPlant$.next(plant);
    }
    // In UtilityService
    getSelectedPlant$(): Observable<PlantList | null> {
        return this.selectedPlant$.asObservable();
    }

    constructor(private _apiService: AppService) { }
    getTokan: [] = [];
    setTokan: string;

    private changeurl = new BehaviorSubject(null);
    setUrlactve = this.changeurl.asObservable();

    private SendDevId = new BehaviorSubject(null);
    receiveDevid = this.SendDevId.asObservable();

    private stationid = new BehaviorSubject(null);
    receivestationid = this.stationid.asObservable();

    setUrl(message: boolean) {
        this.changeurl.next(message);
    }
    sendDeviD(selectedNumber: number) {
        this.SendDevId.next(selectedNumber);
    }
    sendDeviD2(getStationCode: number) {
        this.stationid.next(getStationCode);
    }
    setUserInfo(username, password): Observable<any> {
        return this._apiService.setUserInfoApi(username, password);
    }
    setWeatherUpdates(getStationCode): Observable<any> {
        return this._apiService.setWeatherUpdatesApi(getStationCode);
    }
    getpowerFlowList(getStationCode): Observable<any> {
        return this._apiService.getpowerFlowListApi(getStationCode);
    }

    getHeatMapList(getStationCode): Observable<any> {
        return this._apiService.getHeatMapListApi(getStationCode);
    }
    getEnvBnifits(getStationCode, dt, getDayRang): Observable<any> {
        return this._apiService.getEnvBnifitsApi(
            getStationCode,
            dt,
            getDayRang
        );
    }
    getMonthChart(getStationCode, dt): Observable<any> {
        return this._apiService.getMonthChartApi(getStationCode, dt);
    }
    setChangePassword(ChangePassword): Observable<any> {
        return this._apiService.setChangePasswordApi(ChangePassword);
    }
    getyearChart(getStationCode, dt): Observable<any> {
        return this._apiService.getYearChartApi(getStationCode, dt);
    }
    // new added chart tab
    getliftTimeChart(getStationCode): Observable<any> {
        return this._apiService.getLiftTimeChartApi(getStationCode);
    }

    setPlantDetailList(getStationCode): Observable<any> {
        return this._apiService.setgetPlantDetailsApi(getStationCode);
    }
    countAlertlist(getStationCode): Observable<any> {
        return this._apiService.countAlertlistApi(getStationCode);
    }

    newPvGraphsList(devId, dt: string | Date): Observable<any> {
        if (dt == null)
            dt = new Date();
        return this._apiService.newPvGraphsListApi(devId, dt);
    }

    GetAlarmStatus(): Observable<any> {
        return this._apiService.GetAlarmStatus();
    }

    GetPlantAlarmCount(StationCode: any): Observable<any> {
        return this._apiService.GetPlantAlarmCountAPI(StationCode);
    }
    monthlyRoiGraph(StationCode: any): Observable<any> {
        return this._apiService.getMonthRoiGraph(StationCode);
    }
    getYearlyRoiGraph(StationCode: any): Observable<any> {
        return this._apiService.getYearlyRoiGraph(StationCode);

    }


    setProduct(stationCode: any) {
        this.product$.next(stationCode);
    }

    setfiveMinData(getStationCode): Observable<any> {
        return this._apiService.setfiveMinDataApi(getStationCode);
    }
    setfiveMinDataWithDate(getStationCode, dtEnv): Observable<any> {
        return this._apiService.setfiveMinDataApiWithDate(
            getStationCode,
            dtEnv
        );
    }

    setEmiGraphWithDate(getStationCode, dtEnv): Observable<any> {
        return this._apiService.setEmiGraphApiWithDate(
            getStationCode,
            dtEnv
        );
    }

    sendSubCat(): Observable<any> {
        // return this._apiService.sendSubCatApi();
        return this._apiService.sendSubCatApi();
    }
    sendCat(): Observable<any> {
        // return this._apiService.sendSubCatApi();
        return this._apiService.receiveCategoryApi();
    }

    receiveCategory(): Observable<any> {
        return this._apiService.receiveCategoryApi();
    }

    receiveSource(): Observable<any> {
        return this._apiService.receiveSourceApi();
    }

    receivePreority(): Observable<any> {
        return this._apiService.receivePreorityApi();
    }

    receiveTicketList(search: string): Observable<any> {
        return this._apiService.receiveTicketListApi(search);
    }
    receiveAllTicketList(name: string, page: number, size: number, sort: string, column: string): Observable<any> {
        return this._apiService.receiveAllTicketListApi(name, page, size, sort, column);
    }

    receiveFilteredTicketList(filter: string): Observable<any> {
        return this._apiService.FilterRecvieTicketListApi(filter);
    }

    receiveUser(): Observable<any> {
        return this._apiService.receiveUserApi();
    }
    receiveAllUsers(name: string, page: number, size: number, sort: string | null, column: string | null, user_type: number, role: number | null, status: number | null) {
        return this._apiService.receiveAllUsers(name, page, size, sort, column, user_type, role, status);
    }
    receiveInactiveUsers(name: string, page: number, size: number, sort: string | null, column: string | null, user_type: number) {
        return this._apiService.receiveInactiveUsers(name, page, size, sort, column, user_type);
    }
    receiveAllTraiffTypes(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.receiveAllTraiffTypes(name, page, size, sort, column);
    }
    addTariffTypes(requestBody: any): Observable<any> {
        return this._apiService.addTariffTypes(requestBody);
    }
    editTariffTypes(requestBody: any): Observable<any> {
        return this._apiService.editTariffTypes(requestBody);
    }
    deleteTariffTypes(requestBody: any): Observable<any> {
        return this._apiService.deleteTariffTypes(requestBody);
    }
    receiveAllTraiffCompanies(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.receiveAllTraiffCompanies(name, page, size, sort, column);
    }
    addTariffCompany(requestBody: any): Observable<any> {
        return this._apiService.addTariffCompany(requestBody);
    }
    editTariffCompany(requestBody: any): Observable<any> {
        return this._apiService.editTariffCompany(requestBody);
    }
    deleteTariffCompany(requestBody: any): Observable<any> {
        return this._apiService.deleteTariffCompany(requestBody);
    }
    receiveAllPlantTariffs(name: string, page: number, size: number, sort: string | null, column: string | null, tariff_company: number | null, tariff_type: number | null, plant_id: number | null) {
        return this._apiService.receiveAllPlantTariffs(name, page, size, sort, column, tariff_company, tariff_type, plant_id);
    }

    receivedropdownTraiffTypes() {
        return this._apiService.receivedropdownTraiffTypes();
    }

    receiveAllTariffRates(name: string, page: number, size: number, sort: string | null, column: string | null, tariff_company: number | null, tariff_type: number | null, year: number | null) {
        return this._apiService.receiveAllTariffRates(name, page, size, sort, column, tariff_company, tariff_type, year);
    }
    addTariffRates(requestBody: any): Observable<any> {
        return this._apiService.addTariffRates(requestBody);
    }
    editTariffRates(requestBody: any): Observable<any> {
        return this._apiService.editTariffRates(requestBody);
    }
    deleteTariffRates(requestBody: any): Observable<any> {
        return this._apiService.deleteTariffRates(requestBody);
    }

    receiveUserFilter(filter: string): Observable<any> {
        return this._apiService.FilterreceiveUserApi(filter);
    }

    sendForgot(forgotPassword): Observable<any> {
        return this._apiService.sendForgotApi(forgotPassword);
    }
    receiveNocUser(): Observable<any> {
        return this._apiService.receiveNocUserApi();
    }
    receiveSourceName(): Observable<any> {
        return this._apiService.receiveSourceApi();
    }
    selectCategoryRow(sendIdCat): Observable<any> {
        return this._apiService.selectCategoryRowApi(sendIdCat);
    }
    saveUser(userList): Observable<any> {
        return this._apiService.saveUserApi(userList);
    }
    updateUser(id, userList): Observable<any> {
        return this._apiService.updateUserApi(id, userList);
    }

    updateCategory(categoryEdit): Observable<any> {
        return this._apiService.categoryEditApi(categoryEdit);
    }
    deleteCategory(id): Observable<any> {
        return this._apiService.deleteCategoryApi(id);
    }

    addSubCat(getSubcatadd): Observable<any> {
        return this._apiService.addSubCatApi(getSubcatadd);
    }

    receiveSubCatDate(catid): Observable<any> {
        return this._apiService.receiveSubCatDateaPI(catid);
    }
    deleteSubCategory(deleteSubCat): Observable<any> {
        return this._apiService.deleteSubCategoryApi(deleteSubCat);
    }
    getPriorityUpdate(getPriorityId): Observable<any> {
        return this._apiService.getPriorityUpdateApi(getPriorityId);
    }
    addPriority(priAdd): Observable<any> {
        return this._apiService.addPriorityApi(priAdd);
    }
    updatePriorityList(priUpdateModel): Observable<any> {
        return this._apiService.updatePriorityListApi(priUpdateModel);
    }
    deletePriortyList(deletePri): Observable<any> {
        return this._apiService.deletePriortyListApi(deletePri);
    }
    deleteSourceList(deleteSource): Observable<any> {
        return this._apiService.deleteSourceListApi(deleteSource);
    }
    addSourceList(addSourceModel): Observable<any> {
        return this._apiService.addSourceListApi(addSourceModel);
    }
    getSourceByid(getUpdateId): Observable<any> {
        return this._apiService.getSourceByidApi(getUpdateId);
    }
    updateSourceList(updateSourceModel): Observable<any> {
        return this._apiService.updateSourceListApi(updateSourceModel);
    }
    getPlantsList(): Observable<any> {
        return this._apiService.getPlantsListApi();
    }
    addComplainList(addComplan): Observable<any> {
        return this._apiService.addComplainListApi(addComplan);
    }
    getCategoryBySourceId(sourceId): Observable<any> {
        return this._apiService.getCategoryBySourceIdApi(sourceId);
    }
    getSubCategoryByCatId(catId): Observable<any> {
        return this._apiService.getSubCategoryByCatIdApi(catId);
    }
    changeStatus(priortylist): Observable<any> {
        return this._apiService.changeStatusApi(priortylist);
    }
    changePrioritySelect(changePrioritySelect): Observable<any> {
        return this._apiService.changePrioritySelectApi(changePrioritySelect);
    }
    changeAssignToSend(selectUser): Observable<any> {
        return this._apiService.changeAssignToSendApi(selectUser);
    }
    recvieTicketList(ticektId): Observable<any> {
        return this._apiService.recvieTicketListApi(ticektId);
    }
    receiveAlarm(): Observable<any> {
        return this._apiService.receiveAlarmApi();
    }
    receiveAllAlarm(name: string, page: number, size: number, sort: string | null, column: string | null, stationCode: number | null, region: number | null, lev: number | null): Observable<any> {
        return this._apiService.receiveAllAlarmApi(name, page, size, sort, column, stationCode, region, lev);
    }
    receiveAlarmByStation(name: string, page: number, size: number, sort: string | null, column: string | null, stationCode?: string | null): Observable<any> {
        return this._apiService.receiveAlarmByStation(name, page, size, sort, column, stationCode);
    }
    receiveHistoricalAlarm(name: string, page: number, size: number, sort: string | null, column: string | null): Observable<any> {
        return this._apiService.receiveHistoricalAlarm(name, page, size, sort, column);
    }
    clearAlarms(body: any): Observable<any> {
        return this._apiService.clearAlarms(body);
    }
    unClearAlarms(body: any): Observable<any> {
        return this._apiService.unClearAlarms(body);
    }

    receiveAlarmFilter(filter: string): Observable<any> {
        return this._apiService.receiveAlarmApiFilter(filter);
    }

    receiveAlarmbyID(getAlarm): Observable<any> {
        return this._apiService.receiveAlarmbyIDApi(getAlarm);
    }
    decodeUserCode() {
        this.setTokan = localStorage.getItem('tokan');
        if (this.setTokan) {
            return (this.getTokan = jwtDecode(this.setTokan));
        }
    }
    PlantsdetailsAll(): Observable<any> {
        return this._apiService.PlantsdetailsAllApi();
    }
    selectUserType(): Observable<any> {
        return this._apiService.selectUserTypeAPI();
    }
    selectRoleType(id?: number): Observable<any> {
        return this._apiService.selectUserTypeAPI();
    }
    linkUserPlants(LinkPlantU): Observable<any> {
        return this._apiService.linkUserPlantsApi(LinkPlantU);
    }
    showLinkPlant(userInlist): Observable<any> {
        return this._apiService.showLinkPlantApi(userInlist);
    }
    removeUserPlant(removeLinkPlantList): Observable<any> {
        return this._apiService.removeUserPlantApi(removeLinkPlantList);
    }
    chanePassword(changePass): Observable<any> {
        return this._apiService.chanePasswordApi(changePass);
    }

    inverterPrimeData(getStationCode): Observable<any> {
        return this._apiService.inverterPrimeDataApi(getStationCode);
    }
    pvgetData(getStationCode): Observable<any> {
        return this._apiService.pvgetDataApi(getStationCode);
    }

    setInverterDcGr(stData, setDate): Observable<any> {
        return this._apiService.setInverterDcGrApi(stData, setDate);
    }
    setNormalizdGraph(receivestationResult, setDate): Observable<any> {
        return this._apiService.setNormalizdGraphApi(
            receivestationResult,
            setDate
        );
    }
    setInverterOPGr(stData, setDate): Observable<any> {
        return this._apiService.setInverterOPGrApi(stData, setDate);
    }
    setInverterNOmalPGr(stData): Observable<any> {
        return this._apiService.setInverterNOmalPGraPI(stData);
    }


    getPvVoltageGraph(stData, setDate): Observable<any> {
        return this._apiService.getPvVoltageGraphApi(stData, setDate);
    }
    getPVcurrentValues(stData, setDate): Observable<any> {
        return this._apiService.getPVcurrentValuesApi(stData, setDate);
    }
    getPVPowerValues(stData, setDate): Observable<any> {
        return this._apiService.getPVPowerValuesApi(stData, setDate);
    }
    getBothVoltageCurrentsend(stData, setDate): Observable<any> {
        return this._apiService.getBothVoltageCurrentsendApi(stData, setDate);
    }
    getBothVoltagePowersend(stData, setDate): Observable<any> {
        return this._apiService.getBothVoltagePowersendApi(stData, setDate);
    }
    getBothCurrentPowersend(stData, setDate): Observable<any> {
        return this._apiService.getBothCurrentPowersendApi(stData, setDate);
    }

    updateInstallationCost(stationCode, installationCost): Observable<any> {
        return this._apiService.updateInstallationCostApi(stationCode, installationCost);
    }
    reCalculateRoi(stationCode): Observable<any> {
        return this._apiService.reCalculateRoiApi(stationCode);
    }

    predictedRoiApi(requestBody: any): Observable<any> {
        return this._apiService.predictedRoiApi(requestBody);
    }


    getCommentsApi(ticketId): Observable<any> {
        return this._apiService.getCommentsApi(ticketId);
    }

    addCommentsApi(ticketId, comment, files, type): Observable<any> {
        return this._apiService.addCommentsApi(ticketId, comment, files, type);
    }

    disableUserApi(userId): Observable<any> {
        return this._apiService.disableUserApi(userId);
    }
    enableUserApi(userId): Observable<any> {
        return this._apiService.enableUserApi(userId);
    }

    getUserProfileAPI(): Observable<any> {
        return this._apiService.getUserProfile(localStorage.getItem('userId'));
    }

    updateUserProfileAPI(userProfile: any): Observable<any> {
        return this._apiService.updateUserProfile(localStorage.getItem('userId'), userProfile);
    }
    // new apis
    getAllCities(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.receiveCitites(name, page, size, sort, column);
    }
    addRegionCity(requestBody: any): Observable<any> {
        return this._apiService.addRegionAndCity(requestBody);
    }
    editRegionCity(requestBody: any): Observable<any> {
        return this._apiService.editRegionAndCity(requestBody);
    }
    deleteRegionAndCity(id: number): Observable<any> {
        return this._apiService.deleteRegionAndCity(id);
    }
    // cluster
    getNearbyPlants(name: string, page: number, size: number, sort: string | null, column: string | null, lat: number, lng: number, radius: number): Observable<any> {
        return this._apiService.getNearbyPlants(name, page, size, sort, column, lat, lng, radius);
    }
    getNearbyEmiStations(lat: number, lng: number, radius: number): Observable<any> {
        return this._apiService.getNearbyEmiStations(lat, lng, radius);
    }
    // Drop Downs
    getContractTypeDropDown(): Observable<any> {
        return this._apiService.getContractTypeDropDownApi();
    }
    getRegionDropDownList(): Observable<any> {
        return this._apiService.getRegionDropDownApi();
    }
    getCitiesDropDown(): Observable<any> {
        return this._apiService.getCititesDropDownApi();
    }
    getCitiesByRegionDropDown(id: number): Observable<any> {
        return this._apiService.getCititesByRegionDropDownApi(id);
    }
    updatePlantRegionAssociation(body: any): Observable<any> {
        return this._apiService.updateRegionCityPlant(body);
    }
    getEMIHeatMap(search: string, page: number, size: number, sort: string, column: string, type: string, status: string, contractType: number, region: number, city: number, stationCodes: number[] | null, fromDate?: string | null, toDate?: string | null): Observable<any> {
        return this._apiService.getEMIHeatMap(search, page, size, sort, column, type, status, contractType, region, city, stationCodes, fromDate, toDate);
    }
    getStationsDropDown(): Observable<any> {
        return this._apiService.getStationsDropDown();
    }
    getWapdaData(station_code: string): Observable<any> {
        return this._apiService.getWapdaData(station_code);
    }
    getDevicesData(station_code: string, search?: string): Observable<any> {
        return this._apiService.getDevicesData(station_code, search);
    }
    getPlantsTree(user_id: any): Observable<any> {
        return this._apiService.getPlantsTree(user_id);

    }
    updateUserPlantAssociation(body: any): Observable<any> {
        return this._apiService.updateUserPlant(body);
    }
    receivePlantAlarm(name: string, page: number, size: number, sort: string | null, column: string | null): Observable<any> {
        return this._apiService.receivePlantAlarmApi(name, page, size, sort, column);
    }
    // daily report
    fetchDailyReport(stationCode: string | null, date: string | null) {
        return this._apiService.fetchDailyReport(stationCode, date);
    }
    downloadDailyReport(body: any) {
        return this._apiService.downloadDailyReport(body);
    }
    // monthly report
    fetchMonthlyReport(payload: any) {
        return this._apiService.fetchMonthlyReport(payload);
    }
    downloadMonthlyReport(body: any) {
        return this._apiService.downloadMonthlyReport(body);
    }
    resetUserPassword(payload: any): Observable<any> {
        return this._apiService.resetUserPassworod(payload);
    }
    downloadDevicesReport(stationCode: string) {
        return this._apiService.downloadDevicesReport(stationCode);
    }
    downloadActiveAlarmReport(body: any) {
        return this._apiService.downloadActiveAlarmReport(body);
    }
    downloadPlantReport(body: any) {
        return this._apiService.downloadPlantReport(body);
    }
    getStationInverterData(station_code: string, type?: number | null): Observable<any> {
        return this._apiService.getStationInverterData(station_code, type);
    }
    getWapdaGraphicalView(devId: string | null, powerDevId: string | null, dt: string | Date): Observable<any> {
        if (dt == null)
            dt = new Date();
        return this._apiService.getWapdaGraphicalView(devId, powerDevId, dt);
    }
    downloadWapdaReport(stationCode: string, date: string) {
        return this._apiService.downloadWapdaReport(stationCode, date);
    }
    getPlantComparisonReport(body: any) {
        return this._apiService.getPlantComparisonReport(body);
    }
    downloadPlantComparisonReport(body: any) {
        return this._apiService.downloadPlantComparisonReport(body);
    }
    // user types
    getUserTypesList(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.userTypesList(name, page, size, sort, column);
    }
    addUserType(requestBody: any): Observable<any> {
        return this._apiService.addUserType(requestBody);
    }
    editUserType(requestBody: any): Observable<any> {
        return this._apiService.editUserType(requestBody);
    }
    getUserTypesDropdown(): Observable<any> {
        return this._apiService.getUserTypesDropdown();
    }
    getUserTypesHierarchyDropdown(): Observable<any> {
        return this._apiService.getUserTypesHierarchyDropdown();
    }
    // user roles
    getUserRole(): Observable<any> {
        return this._apiService.getUserRole();
    }
    createUserRole(requestBody: any): Observable<any> {
        return this._apiService.createUserRole(requestBody);
    }
    getRolePermissions(id: number): Observable<any> {
        return this._apiService.getRolePermissions(id);
    }
    updateRolePermissions(permissions: any): Observable<any> {
        return this._apiService.updateRolePermissions(permissions);
    }
    updateUserRole(id: number, requestBody: any): Observable<any> {
        return this._apiService.updateUserRole(id, requestBody);
    }
    deleteUserRole(id: number): Observable<any> {
        return this._apiService.deleteUserRole(id);
    }
    getUserCreationHierarchyRules(): Observable<any> {
        return this._apiService.getUserCreationHierarchyRules();
    }
    createHierarchyRules(payload: any): Observable<any> {
        return this._apiService.createHierarchyRules(payload);
    }
    deleteHierarchyRule(id: number): Observable<any> {
        return this._apiService.deleteHierarchyRule(id);
    }
    getUserRoleByType(id: number): Observable<any> {
        return this._apiService.getUserRoleByType(id);
    }
    // audit trail user
    getAuditTrail(search: string, page: number, size: number, sort: string, column: string, changed_by: string | null,
        event_type: string | null,
        action_type: number | null,
        fromDate?: string | null,
        toDate?: string | null): Observable<any> {
        return this._apiService.getAuditTrail(search, page, size, sort, column, changed_by, event_type, action_type, fromDate, toDate);
    }
    getAllUsersDropdown(): Observable<any> {
        return this._apiService.getAllUsersDropdown();
    }
    // roles list
    getRolesListPaginated(name: string, page: number, size: number, sort: string | null, column: string | null, user_type: number | null) {
        return this._apiService.rolesListPaginated(name, page, size, sort, column, user_type);
    }
    downloadUsersReport(body: any) {
        return this._apiService.downloadUsersReport(body);
    }
    // ticket management
    getTicketPriority(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.getTicketPriority(name, page, size, sort, column);
    }
    addTicketPriority(requestBody: any): Observable<any> {
        return this._apiService.addTicketPriority(requestBody);
    }
    editTicketPriority(requestBody: any): Observable<any> {
        return this._apiService.editTicketPriority(requestBody);
    }
    deletePriority(id: number): Observable<any> {
        return this._apiService.deletePriority(id);
    }
    // ticket configuration
    getCongfigurationList(name: string, page: number, size: number, sort: string | null, column: string | null) {
        return this._apiService.getCongfigurationList(name, page, size, sort, column);
    }
    updateCongfiguration(requestBody: any): Observable<any> {
        return this._apiService.updateCongfiguration(requestBody);
    }
    // ticket list
    getTicketList(name: string, page: number, size: number, sort: string | null, column: string | null, assignee: number | null, priority: number | null, status: number | null) {
        return this._apiService.getTicketList(name, page, size, sort, column, assignee, priority, status);
    }
    assignedTicketUsers(): Observable<any> {
        return this._apiService.assignedTicketUsers();
    }
    assignedTicketUsersFsr(): Observable<any> {
        return this._apiService.assignedTicketUsersFsr();
    }
    getTicketStatusList(): Observable<any> {
        return this._apiService.getTicketStatusList();
    }
    getFsrStatusList(): Observable<any> {
        return this._apiService.getFsrStatusList();
    }
    fetchSeverity(): Observable<any> {
        return this._apiService.fetchSeverity();
    }
    fetchStationInfo(id?: number | null, electrician?: number | null): Observable<any> {
        return this._apiService.fetchStationInfo(id, electrician);
    }
    createTicket(requestBody: any): Observable<any> {
        return this._apiService.createTicket(requestBody);
    }
    updateTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.updateTicket(id, requestBody);
    }
    assignTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.assignTicket(id, requestBody);
    }
    startTicket(id: number): Observable<any> {
        return this._apiService.startTicket(id);
    }
    holdTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.holdTicket(id, requestBody);
    }
    pendingTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.pendingTicket(id, requestBody);
    }
    resolveTicket(id: number): Observable<any> {
        return this._apiService.resolveTicket(id);
    }
    closeTicketApi(id: number, requestBody: any): Observable<any> {
        return this._apiService.closeTicketApi(id, requestBody);
    }
    reopenTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.reopenTicket(id, requestBody);
    }
    cancelTicket(id: number, requestBody: any): Observable<any> {
        return this._apiService.cancelTicket(id, requestBody);
    }
    getTicketDetail(id: number) {
        return this._apiService.getTicketDetail(id);
    }
    getTicketCommunication(id: number) {
        return this._apiService.getTicketCommunication(id);
    }
    // fsr
    getFsrList(filters: {
        search?: string;
        page?: number;
        size?: number;
        sort?: string | null;
        column?: string | null;
        assignee?: number | null;
        status?: number | null;
        origin?: string | null;
        job_visit_type?: string | null;
        city?: number | null;
    } = {}): Observable<any> {
        return this._apiService.getFsrList(filters);
    }
    getFsrDetail(id: number): Observable<any> {
        return this._apiService.getFsrDetail(id);
    }
    createFsr(requestBody: FormData): Observable<any> {
        return this._apiService.createFsr(requestBody);
    }
    updateFsr(id: number, requestBody: FormData): Observable<any> {
        return this._apiService.updateFsr(id, requestBody);
    }
    assignFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.assignFsr(id, requestBody);
    }
    startFsr(id: number): Observable<any> {
        return this._apiService.startFsr(id);
    }
    holdFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.holdFsr(id, requestBody);
    }
    pendingFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.pendingFsr(id, requestBody);
    }
    resolveFsr(id: number): Observable<any> {
        return this._apiService.resolveFsr(id);
    }
    closeFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.closeFsr(id, requestBody);
    }
    reopenFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.reopenFsr(id, requestBody);
    }
    cancelFsr(id: number, requestBody: any): Observable<any> {
        return this._apiService.cancelFsr(id, requestBody);
    }
    approveFsr(id: number): Observable<any> {
        return this._apiService.approveFsr(id);
    }
    getFsrConfigurationList(search: string): Observable<any> {
        return this._apiService.getFsrConfigurationList(search);
    }
    updateFsrConfiguration(requestBody: any): Observable<any> {
        return this._apiService.updateFsrConfiguration(requestBody);
    }
    getFsrJobVisitTypes(): Observable<any> {
        return this._apiService.getFsrJobVisitTypes();
    }
    getFsrComplaintTypes(): Observable<any> {
        return this._apiService.getFsrComplaintTypes();
    }
    getTicketFsr(ticketId: number): Observable<any> {
        return this._apiService.getTicketFsr(ticketId);
    }
    saveTicketFsr(ticketId: number, requestBody: FormData): Observable<any> {
        return this._apiService.saveTicketFsr(ticketId, requestBody);
    }
    sendMessage(id: number, requestBody: FormData): Observable<any> {
        return this._apiService.sendMessage(id, requestBody);
    }
    getNotifications(type: 'details' | 'communication', page: number = 1) {
        return this._apiService.getNotifications(type, page);
    }

    postNotifications(requestBody: { type: 'details' | 'communication' }) {
        return this._apiService.postNotifications(requestBody);
    }

    markNotificationRead(id: number) {
        return this._apiService.markNotificationRead(id);
    }

    markAllNotificationsRead(body: { type: 'details' | 'communication' }) {
        return this._apiService.markAllNotificationsRead(body);
    }

    clearNotification(id: number) {
        return this._apiService.clearNotification(id);
    }

    clearAllNotifications(body: { type: 'details' | 'communication' }) {
        return this._apiService.clearAllNotifications(body);
    }
    getSubscription(userId: number,reportType: 'DAILY' | 'MONTHLY') {
        return this._apiService.getSubscription(userId,reportType);
    }
    createSubscription(payload: any) {
        return this._apiService.createSubscription(payload);
    }
    updateSubscription(payload: any) {
        return this._apiService.updateSubscription(payload);
    }
    deleteSubscription(payload: any) {
        return this._apiService.deleteSubscription(payload);
    }
}